/* eslint-disable react-hooks/exhaustive-deps */
import { Card, FormControl, Grid, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import { useMaterialUIController } from "context";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom";
import { addUserData, fetchRolesData, getMyUserById, updateUserData } from "utils/api";
import { appConstants } from "utils/appConstants";
import { blank, generateDataList, getScreenRight, showResMsg, validateEmailField, validateField } from "utils/generic";
import { genericMessage } from "utils/genericMessages";
import PageTitle from "examples/PageTitle/PageTitle";
const { default: DashboardLayout } = require("examples/LayoutContainers/DashboardLayout");


const errMsg = {
  color: `red`,
  fontSize: `11px`,
};

let LOGIN_DETAILS;
let PLAN_DETAILS;

let routePath = "/myusers";


function AddMyUser() {

  const { id } = useParams();
  const [screenName, setScreenName] = useState("Add New User");
  const [fNameErr, setfNameErr] = useState(false);
  const [lNameErr, setlNameErr] = useState(false);
  const [roleErr, setRoleErr] = useState(false);
  const [disableColor, setDisableColor] = useState(false);
  const [emailTitleErr, setemailTitleErr] = useState('');
  const [emailAddressErrMsg, setEmailAddressErrMsg] = useState("");
  const [roles, setRoles] = useState([]);
  const [userIsChild, setUserIsChild] = useState(false);

  const [controller] = useMaterialUIController();
  const { darkMode, sidenavColor } = controller;
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const [values, setValues] = React.useState({
    firstName: "",
    lastName: "",
    emailAddress: "",
    userRole: "",
    userID: "",
    roleID: "",
    userStatus: "Active",
    id: "",
    userType: "Business",
    userKey: "ChildUser",
    loginURL: appConstants.loginURL,
  });

  if (sessionStorage.getItem('LOGIN_DETAILS') !== undefined && sessionStorage.getItem('LOGIN_DETAILS') != null) {
    LOGIN_DETAILS = JSON.parse(sessionStorage.getItem('LOGIN_DETAILS'));
    values.businessUserID = LOGIN_DETAILS.businessUserID;
    values.userID = LOGIN_DETAILS._id;
  }

  if (sessionStorage.getItem('PLAN_DETAILS') !== undefined && sessionStorage.getItem('PLAN_DETAILS') != null) {
    PLAN_DETAILS = JSON.parse(sessionStorage.getItem('PLAN_DETAILS'));
  }

  const handleChange = (name) => (event) => {
    if (event.target.validity !== undefined && event.target.validity.valid === true) {
      setValues({ ...values, [name]: event.target.value });
    }
    else if (event.target.validity === undefined) {
      setValues({ ...values, [name]: event.target.value });
    }
  };

  useEffect(() => {
    id === undefined ? setScreenName("Add New User") : setScreenName("Edit User");
    (async () => {
      getRight()
      fetchRoles();
      if (id !== undefined) {
        values._id = id
        getMyUserById(values, (data) => {
          if (data.Result_Output.length > 0) {
            setValues(data.Result_Output[0]);
            setUserIsChild(data?.userIsChild)
          }
          else { showResMsg("User Details not found", 2000, false, navigate, routePath); }
        }, dispatch)
      }
    }
    )();
  }, [dispatch])



  async function getRight() {
    let right = await getScreenRight("My Users")
    if (right === "Full Access") {
      setDisableColor(false)
    }
    else setDisableColor(true)

  }

  const clearErrorStates = () => {
    setfNameErr(false);
    setlNameErr(false);
    setRoleErr(false);
    setEmailAddressErrMsg(false);
  };

  const addNewUser = async () => {
    let mandateFlag = false;
    clearErrorStates();
    mandateFlag = validateField(values.firstName, setfNameErr) || mandateFlag;
    mandateFlag = validateField(values.lastName, setlNameErr) || mandateFlag;
    mandateFlag = validateField(values.roleID, setRoleErr) || mandateFlag;
    mandateFlag = validateEmailField(values.emailAddress, setEmailAddressErrMsg, setemailTitleErr) || mandateFlag;
    if (mandateFlag) {
      return;
    }
    const apiFunction = id === undefined ? addUserData : updateUserData;
    apiFunction(values, (data) => {
      console.log("data", data)
      // showResMsg(id ? genericMessage.updated : genericMessage.added, 2000, data.Result_Status, navigate, data.Result_Status ? routePath : '');
      if (data.Result_Status) {
        showResMsg(id === undefined ? genericMessage.added : genericMessage.updated, 1000, data.Result_Status, navigate, routePath);
      } else {
        showResMsg(data.Result_Message, 2000, data.Result_Status);
      }
    }, dispatch);
  };


  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);


  const handleKeyDown = (e) => {
    const inputElement = document.querySelector('.GoogleInput');
    if (e.key === "Enter" && inputElement && inputElement.contains(e.target)) {
      e.preventDefault();
    }
  };


  const isCurrentUser = values.userID === id;
  const fetchRoles = async () => {
    values.planID = PLAN_DETAILS[0].planID;
    fetchRolesData(values, async (data) => {
      if (data.Result_Output.length > 0) {
        values.roleID = data.Result_Output[0]._id;
        setRoles(await generateDataList(data.Result_Output, "_id", "roleName"));
      }

    });
  };


  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: 350,
        overflowY: 'scroll',

      },
    },
  };






  return (
    <DashboardLayout>
      <DashboardNavbar />
      <div style={{ marginTop: "20px" }}>
        <Card sx={{ boxShadow: "none", paddingBottom: "6px" }}>
          <PageTitle screenName={screenName} />
          <MDBox mt={3} mb={3.8}>
            <Grid container spacing={1} style={{ display: "flex", justifyContent: "center" }}>
              <Grid item lg={8} xs={12}>
                {/* <Card sx={{ boxShadow: "none" }}>
              <MDBox
                mx={2}
                mt={-3}
                mb={1.5}
                py={2}
                px={2}
                variant="gradient"
                bgColor={sidenavColor}
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  {screenName}
                </MDTypography>
              </MDBox> */}
                <Grid
                  container
                  p={1.6}
                  px={2.2}
                  columnSpacing={{ xs: 2, sm: 2, md: 3, lg: 3 }}
                  rowSpacing={{ xs: 2, sm: 2, md: 3, lg: 3 }}
                >
                  <Grid item lg={4} xs={12}>
                    <TextField
                      type="text"
                      label="First Name"

                      variant="outlined"
                      fullWidth
                      autoFocus={true}
                      value={values.firstName}
                      onChange={handleChange("firstName")}
                      inputProps={{
                        pattern: "^[a-zA-Z0-9!@#$%^&*()_+=-{};:'<>,./?]+$",
                        maxLength: 30,
                        className: "custom-fieldtext"
                      }}

                    />
                    {fNameErr ? <span style={errMsg}>First Name can't be blank</span> : ""}
                  </Grid>
                  <Grid item lg={4} xs={12}>
                    <TextField
                      type="text"
                      label="Last Name"
                      variant="outlined"
                      fullWidth
                      value={values.lastName}
                      onChange={handleChange("lastName")}
                      inputProps={{
                        pattern: "^[a-zA-Z0-9!@#$%^&*()_+=-{};:'<>,./?]+$",
                        maxLength: 30,
                        className: "custom-fieldtext"
                      }}
                    />
                    {lNameErr ? <span style={errMsg}>Last Name can't be blank</span> : ""}

                  </Grid>
                  <Grid item lg={4} xs={12}>
                    <FormControl fullWidth>
                      <InputLabel id="select-user-role" shrink>Role</InputLabel>
                      <Select
                        labelId="user-role"
                        id="select-user-role"
                        style={{ height: "35.11px" }}
                        label="Role"
                        value={values.roleID}
                        onChange={handleChange("roleID")}
                        // readOnly={id !== undefined}
                        disabled={userIsChild}
                        displayEmpty
                        MenuProps={MenuProps}
                      >
                        <MenuItem value="" disabled>Select User Role</MenuItem>
                        {roles}
                      </Select>
                      {!roleErr && userIsChild ? <span style={errMsg}>Child user can't change role</span> : ""}
                      {roleErr ? <span style={errMsg}>Role can't be blank</span> : ""}
                    </FormControl>
                  </Grid>
                  <Grid item lg={4} xs={12}>
                    <TextField
                      type="text"
                      label="Email Address"
                      variant="outlined"
                      fullWidth
                      inputProps={{
                        maxLength: 50,
                        className: "custom-fieldtext"
                      }}
                      value={values.emailAddress}
                      onChange={handleChange("emailAddress")}
                      disabled={id !== undefined}
                    />
                    {emailAddressErrMsg !== "" ? (
                      <span style={errMsg}>{emailTitleErr}</span>
                    ) : (
                      ""
                    )}
                  </Grid>
                  <Grid item lg={4} xs={12} mb={2.2}>
                    <FormControl fullWidth>
                      <InputLabel id="userStatus">Status </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        style={{ height: "35.11px" }}
                        label="statue"
                        value={values.userStatus}
                        onChange={handleChange("userStatus")}
                        disabled={id === undefined || isCurrentUser}
                      // disabled={id !== undefined}
                      >
                        <MenuItem value="Active">Active</MenuItem>
                        <MenuItem value="Inactive">Inactive</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>
                {/* </Card> */}

              </Grid>
            </Grid>

            <Grid
              container

              // columnSpacing={{ xs: 2, md: 4, lg: 4 }}
              alignItems="center"
              spacing={2}
              style={{ display: "flex", justifyContent: "center" }}
              className="gridbuttons"
            >
              <Grid item xs={12} md={4} spacing={4} lg={1.68}>

                <Link to={"/myusers"}>
                  <MDButton
                    className="btn-block center-container-btn btn-warning btn-back rightSpace"
                    color="warning"
                    fullWidth
                    style={{ height: "40px" }}
                  >
                    Close
                  </MDButton>
                </Link>
              </Grid>
              <Grid item xs={12} md={4} spacing={2} lg={1.68}>
                <MDButton
                  onClick={disableColor ? blank : addNewUser}
                  rel="noreferrer"
                  variant="gradient"
                  className={"btn-block center-container-btn btn-warning btn-back rightSpace"}
                  color={disableColor ? "secondary" : "success"}
                  fullWidth
                  style={{ height: "40px" }}
                >
                  {id ? "Update" : "Save"}
                </MDButton>

              </Grid>
            </Grid>
          </MDBox>
        </Card>
      </div>
    </DashboardLayout>
  );
}

export default AddMyUser;
